import { jsonldSku } from './JsonldStore';

export const updateJsonldSku = (value) => jsonldSku.update((oldValue) => value);
